import warning from 'rc-util/lib/warning';
import { toArray } from './commonUtil';
function getKey(data, index) {
    const { key } = data;
    let value;
    if ('value' in data) {
        ({ value } = data);
    }
    if (key !== null && key !== undefined) {
        return key;
    }
    if (value !== undefined) {
        return value;
    }
    return `rc-index-key-${index}`;
}
export function flattenOptions(options) {
    const flattenList = [];
    function dig(list, isGroupOption) {
        list.forEach(data => {
            if (isGroupOption || !('options' in data)) {
                flattenList.push({
                    key: getKey(data, flattenList.length),
                    groupOption: isGroupOption,
                    data,
                });
            }
            else {
                flattenList.push({
                    key: getKey(data, flattenList.length),
                    group: true,
                    data,
                });
                dig(data.options, true);
            }
        });
    }
    dig(options, false);
    return flattenList;
}
function injectPropsWithOption(option) {
    const newOption = Object.assign({}, option);
    if (!('props' in newOption)) {
        Object.defineProperty(newOption, 'props', {
            get() {
                warning(false, 'Return type is option instead of Option instance. Please read value directly instead of reading from `props`.');
                return newOption;
            },
        });
    }
    return newOption;
}
export function findValueOption(values, options, { prevValueOptions = [] } = {}) {
    const optionMap = new Map();
    options.forEach(flattenItem => {
        if (!flattenItem.group) {
            const data = flattenItem.data;
            optionMap.set(data.value, data);
        }
    });
    return values.map(val => {
        let option = optionMap.get(val);
        if (!option) {
            option = Object.assign({}, prevValueOptions.find(opt => opt._INTERNAL_OPTION_VALUE_ === val));
        }
        return injectPropsWithOption(option);
    });
}
export const getLabeledValue = (value, { options, prevValueMap, labelInValue, optionLabelProp }) => {
    const item = findValueOption([value], options)[0];
    const result = {
        value,
    };
    const prevValItem = labelInValue ? prevValueMap.get(value) : undefined;
    if (prevValItem && typeof prevValItem === 'object' && 'label' in prevValItem) {
        result.label = prevValItem.label;
        if (item && typeof prevValItem.label === 'string' && typeof item[optionLabelProp] === 'string' && prevValItem.label.trim() !== item[optionLabelProp].trim()) {
            warning(false, '`label` of `value` is not same as `label` in Select options.');
        }
    }
    else if (item && optionLabelProp in item) {
        result.label = item[optionLabelProp];
    }
    else {
        result.label = value;
        result.isCacheable = true;
    }
    result.key = result.value;
    return result;
};
function toRawString(content) {
    return toArray(content).join('');
}
function getFilterFunction(optionFilterProp) {
    return (searchValue, option) => {
        const lowerSearchText = searchValue.toLowerCase();
        if ('options' in option) {
            return toRawString(option.label).toLowerCase().includes(lowerSearchText);
        }
        const rawValue = option[optionFilterProp];
        const value = toRawString(rawValue).toLowerCase();
        return (value && lowerSearchText.startsWith(value)) || value.includes(lowerSearchText);
    };
}
export function filterOptions(searchValue, options, { optionFilterProp, filterOption }) {
    const filteredOptions = [];
    let filterFunc;
    if (filterOption === false) {
        return [...options];
    }
    if (typeof filterOption === 'function') {
        filterFunc = filterOption;
    }
    else {
        filterFunc = getFilterFunction(optionFilterProp);
    }
    options.forEach(item => {
        if ('options' in item) {
            const matchGroup = filterFunc(searchValue, item);
            if (matchGroup) {
                filteredOptions.push(item);
            }
            else {
                const subOptions = item.options.filter(subItem => filterFunc(searchValue, subItem));
                if (subOptions.length) {
                    filteredOptions.push(Object.assign(Object.assign({}, item), { options: subOptions }));
                }
            }
            return;
        }
        if (filterFunc(searchValue, injectPropsWithOption(item))) {
            filteredOptions.push(item);
        }
    });
    return filteredOptions;
}
export function getSeparatedContent(text, tokens) {
    if (!tokens || !tokens.length) {
        return null;
    }
    let match = false;
    function separate(str, [token, ...restTokens]) {
        if (!token) {
            return [str];
        }
        const list = str.split(token);
        match = match || list.length > 1;
        return list.reduce((prevList, unitStr) => [...prevList, ...separate(unitStr, restTokens)], []).filter(unit => unit);
    }
    const list = separate(text, tokens);
    return match ? list : null;
}
export function isValueDisabled(value, options) {
    const option = findValueOption([value], options)[0];
    return option.disabled;
}
export function fillOptionsWithMissingValue(options, value, optionLabelProp, labelInValue) {
    const values = toArray(value).slice().sort();
    const cloneOptions = [...options];
    const optionValues = new Set();
    options.forEach(opt => {
        if (opt.options) {
            opt.options.forEach((subOpt) => {
                optionValues.add(subOpt.value);
            });
        }
        else {
            optionValues.add(opt.value);
        }
    });
    values.forEach(item => {
        const val = labelInValue ? item.value : item;
        if (!optionValues.has(val)) {
            cloneOptions.push(labelInValue
                ? {
                    [optionLabelProp]: item.label,
                    value: val,
                }
                : { value: val });
        }
    });
    return cloneOptions;
}
